import { useDispatch, useSelector } from 'react-redux';
import { selectOffersSlice, setOffers } from '../../../store/slices/OfferSlice';

const useOffersStuff = () => {
  const offersSlice = useSelector(selectOffersSlice);
  const dispatch = useDispatch();
  const reset = () => {
    dispatch(
      setOffers({
        unlockedOffers: [],
        eligibleOffers: [],
        appliedOffers: [],
      }),
    );
  };

  return { ...offersSlice, reset };
};

export default useOffersStuff;
